import useSWR, { useSWRConfig } from "swr";
import { useApiClient } from "@/hooks/useApiClient";
import { reportRegistrationMapError } from "@/features/map/hooks/useRegistrationMapApi";

interface RegistrationMapTileResponse {
  pmtilesUrl: string;
}

interface UseRegistrationMapTileResult {
  pmtilesUrl: string | undefined;
  isLoading: boolean;
}

/** 登記所備付地図のPMTiles URLを取得する。空文字は未公開として扱う。 */
export const useRegistrationMapTile = (
  enabled: boolean
): UseRegistrationMapTileResult => {
  const { apiClient } = useApiClient();
  const swrConfig = useSWRConfig();

  const fetchTile = async (
    url: string
  ): Promise<RegistrationMapTileResponse> => {
    const response = await apiClient.get<RegistrationMapTileResponse>(url);
    return response.data;
  };

  const { data, isLoading } = useSWR(
    enabled ? "/trustart/registration-map/tile" : null,
    fetchTile,
    {
      revalidateOnFocus: false,
      // 取得に失敗するとレイヤーがパネルから消えるだけで原因が分からないため、
      // エラー監視へも送る。既存の汎用トーストは全体設定の onError に任せる。
      onError: (error: unknown, key) => {
        reportRegistrationMapError(error);
        swrConfig.onError(error, key, swrConfig);
      },
    }
  );

  return {
    pmtilesUrl: data?.pmtilesUrl === "" ? undefined : data?.pmtilesUrl,
    isLoading,
  };
};
